const ApplyRounding = (value, decimals) => {
  return Number(value).toFixed(decimals);
};
export default ApplyRounding;
